module.exports = __webpack_public_path__ + "img/jxgl.d1cb67ca.png";